import { Button } from "@/dentlab/src/components/ui/button";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

interface SupportToolCardProps {
	title: string;
	description: string;
	icon: ReactNode;
	path: string;
}

export const SupportToolCard: React.FC<SupportToolCardProps> = ({
	title,
	description,
	icon,
	path,
}) => {
	const navigate = useNavigate();

	return (
		<div className="border rounded-lg p-6 hover:bg-gray-50 transition-colors cursor-pointer group" 
			 onClick={() => navigate(path)}>
			<div className="flex items-start justify-between mb-3">
				<div className="flex items-center gap-3">
					<div className="p-2 bg-blue-100 rounded-lg group-hover:bg-blue-200 transition-colors">
						{icon}
					</div>
					<div>
						<h3 className="font-semibold text-lg">{title}</h3>
					</div>
				</div>
			</div>
			
			<p className="text-gray-600 mb-4 leading-relaxed">
				{description}
			</p>
			
			<Button 
				variant="outline" 
				size="sm"
				className="group-hover:bg-blue-50"
				onClick={(e) => {
					e.stopPropagation();
					navigate(path);
				}}
			>
				Tool öffnen
			</Button>
		</div>
	);
};